import { render, staticRenderFns } from "./ColaboradorModal.vue?vue&type=template&id=47c4148f&scoped=true"
import script from "./ColaboradorModal.vue?vue&type=script&lang=js"
export * from "./ColaboradorModal.vue?vue&type=script&lang=js"
import style0 from "./ColaboradorModal.vue?vue&type=style&index=0&id=47c4148f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c4148f",
  null
  
)

export default component.exports